import { useNavigate } from "react-router";
import {
  Button,
  Card,
  Chip,
  Container,
  HeaderBar,
  Icon,
  Loader,
  TypoGraph,
} from "components";
import colors from "theme/colors";
import styles from "./paymentsCategory.module.scss";
import strings from "strings";
import { useEffect, useState } from "react";
import { IParentCompanyPaymentTypeSummary, IPaymentSummary } from "interfaces";
import {
  getCurrentUserDetails,
  getPaymentSummary,
  getPaymentSummaryByParentCompany,
} from "api";

const t = strings.PAYMENTS_STRING;

export interface IPaymentSummaryCardProps {
  item: IPaymentSummary;
  key?: string;
}

const PaymentsCategory = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [paymentSummary, setPaymentSummary] = useState<IPaymentSummary[]>();
  const [parentCompanySummary, setParentCompanySummary] =
    useState<IParentCompanyPaymentTypeSummary[]>();
  const [receivablesHomeByCompanyEnabled, setReceivablesHomeByCompanyEnabled] =
    useState<boolean>(false);

  const navigate = useNavigate();

  useEffect(() => {
    loadLandingData();
  }, []);

  const LOSS_DRAFT_PAYMENT_TYPE_ID = 15;

  const loadLandingData = async () => {
    try {
      const userDetails = (await getCurrentUserDetails())?.data;
      const enabled = Boolean(userDetails?.receivablesHomeByCompanyEnabled);
      setReceivablesHomeByCompanyEnabled(enabled);

      if (enabled) {
        const summary = (await getPaymentSummaryByParentCompany(LOSS_DRAFT_PAYMENT_TYPE_ID))?.data;
        setParentCompanySummary(summary);
      } else {
        const summary = (await getPaymentSummary())?.data;
        setPaymentSummary(summary);
      }
    } finally {
      setLoading(false);
    }
  };
  const navigateToPaymentList = (typeId: number) => {
    navigate(`${typeId}`);
  };

  const navigateToLossDraftByParent = (item: IParentCompanyPaymentTypeSummary) => {
    const ids = item.companyIds && item.companyIds.length > 0
      ? item.companyIds
      : [item.parentCompanyId];
    navigate(
      `/payments/${LOSS_DRAFT_PAYMENT_TYPE_ID}?companiesFilterId=${ids.join(",")}`
    );
  };

  const ALL_PAYMENT_TYPES = 99;

  const PaymentSummaryCards = (props: IPaymentSummaryCardProps) => {
    const { item } = props;
    const icons = [
      "icon_paymentsCategory",
      "icon_securityDeposit",
      "icon_commision",
      "icon_rent",
      "icon_hud",
      "icon_other",
      "icon_remittance",
      "icon_optionFee",
      "icon_closingFunds",
      "icon_paymentsCategory",
      "icon_paymentsCategory",
      "icon_paymentsCategory",
      "icon_paymentsCategory",
      "icon_paymentsCategory",
      "icon_paymentsCategory",
      "icon_paymentsCategory",
    ];
    return (
      <>
        <Container>
          <Card sxContent={{ display: "grid", gridGap: "10px" }}>
            <Container>
              <Icon
                name={icons[item.typeId == ALL_PAYMENT_TYPES ? 0 : item.typeId]}
                type="icons"
                size={48}
                boxClassName={styles.icon}
              />
              <TypoGraph
                variant="h3"
                content={item.typeId === 2 ? "Commission Check" : item.typeName}
                align="center"
              />
            </Container>
            <Container className={styles.chipContainer}>
              <Chip
                label={item.newCount || "0"}
                variant="filled"
                className={styles.chip}
                style={{ backgroundColor: `${colors.success}` }}
              />
              <Chip
                label={item.dueCount || "0"}
                variant="filled"
                className={styles.chip}
                style={{ backgroundColor: `${colors.due}` }}
              />
              <TypoGraph variant="overline" content="New" align="center" />
              <TypoGraph variant="overline" content="Due" align="center" />
            </Container>
            <Container className={styles.btnContainer}>
              <Button
                id={`View ${item.typeName}`}
                variant="outlined"
                label="View"
                onClick={() => navigateToPaymentList(item.typeId)}
                className={styles.viewBtn}
              />
            </Container>
          </Card>
        </Container>
      </>
    );
  };

  if (loading) {
    return <Loader loading={loading} />;
  }

  return (
    <Container>
      <HeaderBar title={t.RECEIVABLES} />
      <Container className={styles.paymentCategoryContainer}>
        {!receivablesHomeByCompanyEnabled &&
          paymentSummary?.map((item, index) => (
            <PaymentSummaryCards item={item} key={`key-${index}`} />
          ))}

        {receivablesHomeByCompanyEnabled &&
          parentCompanySummary?.map((item, index) => (
            <Container key={`parent-company-key-${index}`}>
              <Card sxContent={{ display: "grid", gridGap: "10px" }}>
                <Container>
                  <Icon
                    name={"icon_paymentsCategory"}
                    type="icons"
                    size={48}
                    boxClassName={styles.icon}
                  />
                  <TypoGraph variant="h3" content={item.parentCompanyName} align="center" />
                </Container>
                <Container className={styles.chipContainer}>
                  <Chip
                    label={String(item.newCount ?? 0)}
                    variant="filled"
                    className={styles.chip}
                    style={{ backgroundColor: `${colors.success}` }}
                  />
                  <Chip
                    label={String(item.dueCount ?? 0)}
                    variant="filled"
                    className={styles.chip}
                    style={{ backgroundColor: `${colors.due}` }}
                  />
                  <TypoGraph variant="overline" content="New" align="center" />
                  <TypoGraph variant="overline" content="Due" align="center" />
                </Container>
                <Container className={styles.btnContainer}>
                  <Button
                    id={`View ${item.parentCompanyName}`}
                    variant="outlined"
                    label="View"
                    onClick={() => navigateToLossDraftByParent(item)}
                    className={styles.viewBtn}
                  />
                </Container>
              </Card>
            </Container>
          ))}
      </Container>
    </Container>
  );
};

export default PaymentsCategory;
